import apiService from "../../api/api.service";
import { PopupResponse, MarkPopupViewedResponse } from "./popup.types";

export const fetchPopup = (): Promise<PopupResponse> => {
  return apiService.get<PopupResponse>("/popups");
};

export const markPopupViewed = (popup_id: number): Promise<MarkPopupViewedResponse> => {
  return apiService.post<MarkPopupViewedResponse>("/popups/mark-as-viewed", { popup_id });
};